// Module
var code = `<div><ul class="tabs" ng-transclude></ul><div class="tabs-container"><div class="tab" ng-repeat="tab in tabs" ng-class="{'active': tab.active}" tab-content-transclude="tab"></div></div></div>`;
// Exports
export default code;